// extracted by mini-css-extract-plugin
module.exports = {"container":"AFNa7Df9","image":"_2SbbtZdt","textContainer":"LN1-trfx","title":"_2qp8fkgU","text":"_2zk8kJx2"};